import type { SearchSiteView } from '../../../api/src/search-metrics/search-metrics.types';

export const siteSortNames = {
  domain: 'Домен · А–Я',
  clicks: 'Клики · по убыванию',
  impressions: 'Показы · по убыванию',
};
export type SiteSort = keyof typeof siteSortNames;

export function sortMetricSites(sites: SearchSiteView[], sort: SiteSort): SearchSiteView[] {
  const total = (site: SearchSiteView, key: 'clicks' | 'impressions') => {
    if (!site.sources.length || site.sources.some((source) => source.current[key] === null))
      return null;
    return site.sources.reduce((sum, source) => sum + source.current[key]!, 0);
  };
  return [...sites].sort((a, b) => {
    if (sort !== 'domain') {
      const left = total(a, sort);
      const right = total(b, sort);
      if (left === null && right !== null) return 1;
      if (left !== null && right === null) return -1;
      if (left !== null && right !== null && left !== right) return right - left;
    }
    return a.siteKey.localeCompare(b.siteKey, 'ru');
  });
}
